import React from 'react';
import { EmptySpace } from './styles';

export default ({ mWidth, height, backgroundColor }:
    { mWidth?: string, height?: string, backgroundColor?: string }) => (
    <EmptySpace mWidth={mWidth} height={height} backgroundColor={backgroundColor}/>
);